(function() {
    let minDate = new Date();
    flatpickr(".datepicker", {
        "locale": 'fr',
        "dateFormat": "d/m/Y",
        "defaultDate": minDate,
        "minDate": minDate,
        "allowInput": true,
	});

	minDate.setDate(minDate.getDate() + 1);
    flatpickr(".datetimepicker", {
        "locale": 'fr',
        "enableTime": true,
        "time_24hr": true,
        "dateFormat": "d/m/Y - H\\hi",
        "defaultDate": minDate,
        "minDate": minDate,
        "allowInput": true,
        "position": "above"
    });
})();
